import Loading from '@Components/Loading/Loading'
import React from 'react'
import { connect } from 'react-redux'
import Header from '../Header/Header'
import './MedicalLayout.scss'

interface IEducatorLayout {
    children: React.ReactNode
    isLoading?: boolean
}

const MedicalLayout = ({ children, isLoading }: IEducatorLayout) => {
    return (
        <div className="medical-layout">
            <Header />
            <div className="medical-wrapper">
                <div className="medical-content">
                    <Loading isLoading={isLoading} /> {children}
                </div>
            </div>
        </div>
    )
}

// store section
const mapStateToProps = (state: any) => {
    const isLoading = state?.shared?.loadings?.pageLoading
    return {
        isLoading,
    }
}

export default connect(mapStateToProps, null)(MedicalLayout)
